import Vue from "vue";
import moengage from "@moengage/web-sdk";
// Resolved once at boot; the MoEngage widget config is not reactive.
import i18n from '@/libs/i18n'
import { readStoredTheme } from '@/theme/applyTheme'
import { resolveAccent } from '@/theme/presets'

// The inbox is drawn by MoEngage with plain colour values, read once here: it
// takes the saved accent from the next page load on, not live.
const savedTheme = readStoredTheme()
const brand = resolveAccent(savedTheme.accent, savedTheme.custom).primary

moengage.initialize(
  {
    app_id: process.env.VUE_APP_MOENGAGE_ID,
    cluster: process.env.VUE_APP_MOENGAGE_CLUSTER,
    enableSPA: true,
    debug_logs: 0,
    cards: {
      enable: true,
      placeholder: "#cardIcon",
      navigationBar: {
        backgroundColor: brand,
      },
      tab: {
        active: {
          color: brand,
          underlineColor: brand,
        }
      },
      noDataContent: {
        img: "/no_record.svg",
        text: i18n.t('nav.noNotifications'),
      },
      optionButtonColor: brand,
      dateTimeColor: brand,
      unclickedCardIndicatorColor: brand,
      refreshIcon: "/refresh_icon.svg",
    },
    personalize: {
      init: true,
    },
    // Path to public/serviceworker.js, which backs web push. This MUST live
    // inside initData: initialize() takes a single argument, so passing it as a
    // second one was silently dropped and the SDK fell back to its default --
    // which happens to be this same path, so push worked by luck, not config.
    swPath: "/serviceworker.js",
  }
);

Vue.prototype.$moengage = moengage;

